import { pixelMask, TILE_SYMBOLS } from '@/utils/tilePixels';
import { colors } from '@/styles';
import { Signal } from '@/models/data/Signal';
import { TileType } from '@/models/TileTypes';
import {
  defaultTileGraphics,
  connectionGraphics,
} from '@/models/tiles/DefaultTileGraphics';
import { TileDefinition, TileGraphicsDefinition } from '@/models/tiles/TileDefinition';
import { Side, TileSideIOType } from '@/schemas/tiles';
import { standardBuildAndConnect } from '@/models/logic/utils';

export class InverterTile implements TileDefinition {
  graphics = notTileGraphicsDefinition;
  type = TileType.Not;

  name = 'Inverter';
  canRotate = true;

  createDefaultState = () => null;
  buildAndConnectNodes = (data: any) => standardBuildAndConnect('NOT', data, this);

  ioSides = {
    [Side.TOP]: { type: TileSideIOType.NONE, forceConnection: false },
    [Side.RIGHT]: { type: TileSideIOType.OUTPUT, forceConnection: true },
    [Side.BOTTOM]: { type: TileSideIOType.NONE, forceConnection: false },
    [Side.LEFT]: { type: TileSideIOType.INPUT, forceConnection: true },
  };
}

export const notTileGraphicsDefinition: TileGraphicsDefinition = {
  type: TileType.Not,
  draw: function (g, { meta, connections, context }): void {
    defaultTileGraphics(g);

    const ioSides = {
      [Side.TOP]: { type: TileSideIOType.NONE, forceConnection: false },
      [Side.RIGHT]: { type: TileSideIOType.OUTPUT, forceConnection: true },
      [Side.BOTTOM]: { type: TileSideIOType.NONE, forceConnection: false },
      [Side.LEFT]: { type: TileSideIOType.INPUT, forceConnection: true },
    };

    connectionGraphics(
      g,
      colors.signalColor,
      colors.noSignalColor,
      meta,
      connections,
      ioSides,
      context,
    );

    const color =
      meta.outputs.right === Signal.HIGH ? colors.signalColor : colors.noSignalColor;
    pixelMask(g, TILE_SYMBOLS.inverter, 3, 5, color);
    // The solid circle keeps its stepped outline and touches the triangle tip.
    pixelMask(g, ['.###.', '#####', '#####', '#####', '.###.'], 16, 10, color);
  },
};
